const PICKER_WHEEL = "PICKER_WHEEL"
const RTG = "RTG"

export default {
    PICKER_WHEEL,
    RTG
}